import { THEME_COLORS } from '../../shared/index.ts';
import { PREFIX } from '../../shared/utils/index.ts';

export function getColor(color: keyof THEME_COLORS) {
  return `var(${PREFIX.COLOR}${color})`;
}
